import { render, staticRenderFns } from "./BarcodeReader.vue?vue&type=template&id=160b7cf2&scoped=true&"
import script from "./BarcodeReader.vue?vue&type=script&lang=js&"
export * from "./BarcodeReader.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeReader.vue?vue&type=style&index=0&id=160b7cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160b7cf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VSpeedDial})
